/**
 * Ember UserAgent initializer
 *
 * Supports auto injection of the userAgent service app-wide.
 * Generated by the ember-useragent addon.
 */
export function initialize() {
  const application = arguments[1] || arguments[0];
  application.inject('controller', 'userAgent', 'service:userAgent');
  application.inject('component', 'userAgent', 'service:userAgent');
  application.inject('route', 'userAgent', 'service:userAgent');
  application.inject('view', 'userAgent', 'service:userAgent');
}
export default {
  name: 'user-agent',
  initialize
};